"use client";
import L, { useRef as f, useState as j, useEffect as z } from "react";
import { getSiteBreakpoints as M } from "../../../../../utils/breakpoints.js";
import { parseClassNames as m } from "@ddg-frontend/fe-essentials";
const $ = (e) => {
  const {
    fetchPriority: n = null,
    lazyLoading: l = !0,
    styles: d = "",
    onLoad: r = null,
    onError: t = null,
    decoding: o = "async",
    itemImage: h,
    // breakpoints = { S: "480", M: "768", L: "960", XL: "1200" },
    breakpoints: p = M()
  } = e, u = B(h), a = f(), c = f(), w = f(!0), y = f(!1), g = T(p), [i] = j(k({ sources: u, currentViewport: g })), O = () => {
    const s = c.current.parentElement;
    s.classList.remove("loading-img", "placeholder"), s.style.paddingTop = null;
  }, S = (s, X) => {
    w.current && (w.current = !1, y.current = !0, s.type === "load" && O(), typeof X == "function" && X(s));
  };
  return z(() => {
    var s;
    if ((s = c == null ? void 0 : c.current) != null && s.complete && !y.current && w.current) {
      y.current = !0;
      const X = c.current.src;
      c.current.src = X;
    }
  }, []), /* @__PURE__ */ L.createElement(
    "picture",
    {
      ref: a,
      className: `${l ? "loading-img" : ""} ${(i == null ? void 0 : i.width) !== 0 && (i == null ? void 0 : i.height) !== 0 ? "placeholder" : ""}`
    },
    (u == null ? void 0 : u.length) > 0 ? u.map((s, X) => {
      let x = p[Object.keys(s)[0]];
      return s[Object.keys(s)[0]].map((E, v) => /* @__PURE__ */ L.createElement(
        N,
        {
          key: v,
          mediaQuery: u.length - 1 !== X ? x : null,
          src: E
        }
      ));
    }) : null,
    /* @__PURE__ */ L.createElement(
      "img",
      {
        ref: c,
        className: m([{ "lazy-loading": l }, d]),
        loading: l ? "lazy" : null,
        src: i == null ? void 0 : i.url,
        decoding: o,
        onLoad: (s) => S(s, r),
        onError: (s) => S(s, t),
        alt: h.alt || "",
        width: i == null ? void 0 : i.width,
        height: i == null ? void 0 : i.height,
        fetchPriority: n,
        "aria-hidden": h.alt ? null : !0
      }
    )
  );
}, N = ({ mediaQuery: e, src: n }) => /* @__PURE__ */ L.createElement(
  "source",
  {
    media: e ? `(min-width:${e}px)` : null,
    srcSet: n.url,
    type: `image/${n.type ? n.type : "jpg"}`
  }
), B = (e) => {
  const n = ["XXL", "XL", "L", "M", "S", "XS"], l = ["avif", "webp"], d = [];
  return Object.keys(e.viewports).map((r) => {
    const t = r.replace(/image|background/g, "");
    if (e.viewports[r] && n.includes(t)) {
      const o = {};
      o[t] = [], e.viewports[r].split(/,\s|,/g).map((p) => {
        const u = p.split("?")[0].split("#")[0], a = u.match(/\.[0-9a-z]+$/) ? u.match(/\.[0-9a-z]+$/)[0] : null;
        if (p.length > 0) {
          const c = {};
          c.type = a ? a == null ? void 0 : a.replace(".", "") : null, c.url = p, c.width = e.width && e.width[r] ? e.width[r] : null, c.height = e.height && e.height[r] ? e.height[r] : null, o[t].push(c);
        }
      }), o[t].sort((p, u) => {
        const a = l.indexOf(p.type) >= 0 ? l.indexOf(p.type) : o[t].length, c = l.indexOf(u.type) >= 0 ? l.indexOf(u.type) : o[t].length;
        return a - c;
      }), d.push(o);
    }
  }), d.sort(
    (r, t) => n.indexOf(Object.keys(r)[0]) - n.indexOf(Object.keys(t)[0])
  ), d;
}, T = (e) => {
  let n;
  return typeof window < "u" ? n = window.innerWidth : n = e.XS, n < e.S ? "XS" : n < e.M ? "S" : n < e.L ? "M" : n < e.XL ? "L" : n < e.XXL ? "XL" : "XXL";
}, V = ({ sources: e, currentViewport: n = "XXL" }) => {
  const l = {
    XS: ["S", "M", "L", "XL", "XXL"],
    S: ["XS", "M", "L", "XL", "XXL"],
    M: ["S", "XS", "L", "XL", "XXL"],
    L: ["M", "S", "XS", "XL", "XXL"],
    XL: ["L", "M", "S", "XS", "XXL"],
    XXL: ["XL", "L", "M", "S", "XS"]
  }, d = (t) => e.findIndex((o) => Object.keys(o)[0] === t) !== -1 ? t : null;
  let r = null;
  for (let t = 0; t < l[n].length; t++) {
    const o = l[n][t];
    if (r !== null)
      break;
    r = d(o);
  }
  return r;
}, k = ({ sources: e, currentViewport: n }) => {
  let l = null;
  const d = ({ sources: r, currentViewport: t }) => {
    if (r.length === 0 || !t)
      return null;
    const o = r.filter(
      (h) => Object.keys(h)[0] === t
    );
    if (o && o.length)
      l = o[0][t][o[0][t].length - 1];
    else {
      const h = V({ sources: r, currentViewport: t });
      d({
        sources: r,
        currentViewport: h
      });
    }
  };
  return d({ sources: e, currentViewport: n }), l;
}, b = L.memo($);
export {
  b as default
};
